import React, { FunctionComponent, SVGProps } from 'react'

export const IconTelegram: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.09992 5.70927C5.39487 3.83803 8.25885 2.60439 9.69185 2.00835C13.7834 0.306557 14.6335 0.0109368 15.1877 0.0010712C15.3095 -0.000971665 15.582 0.0292328 15.7586 0.172466C15.9076 0.293409 15.9486 0.456785 15.9683 0.571453C15.9879 0.68612 16.0123 0.947335 15.9929 1.15144C15.7712 3.48107 14.8118 9.13447 14.3237 11.7437C14.1172 12.8478 13.7105 13.2179 13.3168 13.2542C12.4613 13.3329 11.8116 12.6887 10.9829 12.1455C9.68624 11.2956 8.95369 10.7664 7.69503 9.93698C6.24042 8.97842 7.18338 8.45158 8.01236 7.59057C8.22931 7.36524 11.999 3.93644 12.0719 3.62539C12.0811 3.58649 12.0895 3.44148 12.0034 3.36491C11.9172 3.28835 11.7901 3.31453 11.6983 3.33535C11.5683 3.36487 9.4968 4.73404 5.48389 7.44287C4.89591 7.84663 4.36333 8.04335 3.88616 8.03304C3.36012 8.02168 2.34822 7.73561 1.59598 7.49109C0.673328 7.19117 -0.0599784 7.0326 0.00387615 6.52325C0.0371355 6.25794 0.402482 5.98662 1.09992 5.70927Z"
        stroke="none"
      />
    </svg>
  )
}
